import React, { useMemo } from 'react';
import { RefinementListProvided } from 'react-instantsearch-core';
import { connectRefinementList } from 'react-instantsearch-dom';
import { Filter } from '../Filter/Filter';
import {
    StyledChunkSizeFilters,
    StyledOtherContainer,
    StyledRangeContainer,
    StyledSizeContainer,
} from './styled';
import { useFilterType } from '~/features/productsList/hooks';
import { weakKey } from '~/shared/utils/jsx';
import { FilterRange } from '../FilterRange';

type Props = {
    attribute: string;
    // isActive: boolean;
} & RefinementListProvided;

const CustomRefinementList = ({ items, refine, attribute }: Props) => {
    const filterType = useFilterType(attribute);
    // console.log('isActive', isActive, items);

    const sizes = useMemo(() => {
        if (filterType === 'Size') {
            const chunkSize = 20;
            const arrayChunks = [];
            for (let i = 0; i < items.length; i += chunkSize) {
                arrayChunks.push(items.slice(i, i + chunkSize));
            }
            return arrayChunks;
        }
        return [];
    }, [filterType, items]);

    return (
        <div>
            {filterType === 'Price' ? (
                <StyledRangeContainer>
                    <FilterRange attribute={attribute} step={1} name={attribute} />
                </StyledRangeContainer>
            ) : null}
            {filterType === 'Other' ? (
                <StyledOtherContainer>
                    {items?.map(({ value, label, isRefined, count }) => {
                        return (
                            <Filter
                                key={`other-${label}`}
                                isRefined={isRefined}
                                keyName={value?.toString()}
                                value={value}
                                label={label}
                                count={count}
                                attribute={attribute || ''}
                                changeHandler={refine}
                            />
                        );
                    })}
                </StyledOtherContainer>
            ) : null}
            {filterType === 'Size' ? (
                <StyledSizeContainer>
                    {sizes.map((group) => (
                        <StyledChunkSizeFilters key={weakKey(group)}>
                            {group?.map(({ value, label, isRefined, count }) => {
                                // Filters of type Size have a layout where only a toggle
                                // button is shown instead of a label and checkbox
                                return (
                                    <Filter
                                        isToggleButton={true}
                                        key={`size-${label}`}
                                        isRefined={isRefined}
                                        keyName={value?.toString()}
                                        value={value}
                                        label={label}
                                        count={count}
                                        attribute={attribute || ''}
                                        changeHandler={refine}
                                    />
                                );
                            })}
                        </StyledChunkSizeFilters>
                    ))}
                </StyledSizeContainer>
            ) : null}
        </div>
    );
};

export const FilterGroupAttributes = React.memo(connectRefinementList(CustomRefinementList));
